import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { CustomConfirmAlert as confirmAlert } from '../../custom-confirm-alert';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem, MenuButton } from '@szhsin/react-menu';
import ApiClient from "../../../services/api-client";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import useStore from "../../../hooks/useStore";

const PresalesActionRenderer = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const [actionElement, setActionElement] = useState(<span></span>);
    const navigate = useNavigate();

    useImperativeHandle(ref, () => ({
        refresh(params) {}
    }));

    const handlePrint = () => {
        var _data = props.data;
        var companyId = useStore.getState().selectedCompany?.id;
        ApiClient.getSaleInstancePrintForm(companyId, _data.id).then(
            response => {
                var _template = response.data.templateSettings;
                var printData = response.data.saleInstance;
                props.colDef.cellRendererParams.setTemplate(_template);
                var saleInstance = props.colDef.cellRendererParams.getPrintSale(printData);
                saleInstance.LOGO = _template.logo;
                saleInstance.IBAN = _template.iban;
                saleInstance.MOREINFO = _template.moreInfo;
                props.colDef.cellRendererParams.onClickPrint(saleInstance);
            },
            error => {
                console.error(
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString()
                );
            }
        );
    };

    const handleCancel = () => {
        var id = props.data.id;
        var companyId = useStore.getState().selectedCompany.id;

        confirmAlert({
            title: t("submitConfirm"),
            message: t("deletePreSaleConfirm"),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => {
                        var rowNode = props.node;
                        props.colDef.cellRendererParams.blockUi(true);
                        ApiClient.cancelMyDataInvoice(companyId, id).then(
                            response => {
                                if (response.data.response[0].statusCode == "Success") {
                                    var cancelMark = response.data.response[0].cancellationMark;
                                    if (cancelMark) {
                                        props.api.refreshInfiniteCache();
                                    } else {
                                        props.api.refreshInfiniteCache();
                                    }
                                    toast.success(t("preSaleDeleted"));
                                } else {
                                    var errors = response.data.response[0].errors.error;
                                    errors.forEach(e => {
                                        toast.error(e.message, { autoClose: 5000 });
                                    });
                                }
                                props.colDef.cellRendererParams.blockUi(false);
                            },
                            error => {
                                console.error(
                                    (error.response && error.response.data && error.response.data.message) ||
                                    error.message ||
                                    error.toString()
                                );
                                props.colDef.cellRendererParams.blockUi(false);
                            }
                        );
                    }
                },
                {
                    label: t('No'),
                    onClick: () => {}
                }
            ]
        });
    };

    const showEmailModal = () => {
        var companyId = useStore.getState().selectedCompany.id;
        ApiClient.findCompanyCustomerContacts(companyId, props.data.customerTaxPayerId, props.data.customerName).then(
            response => {
                var contacts = response.data;
                var _contacts = contacts.map(e => ({
                    value: e.email,
                    name: e.name,
                    email: e.email,
                    label: e.email
                }));
                var columns = [
                    { header: t("Name"), field: "name", flex: 6 },
                    { header: t("Email"), field: "email", flex: 6 }
                ];
                var _company = useStore.getState().selectedCompany;
                if (_company.accountantEmail) {
                    _contacts.push({
                        value: _company.accountantEmail,
                        name: t("companyAccountant"),
                        email: _company.accountantEmail,
                        label: _company.accountantEmail
                    });
                }
                var opts = { data: _contacts, columns: columns };
                props.colDef.cellRendererParams.setShowEmailModal(true);
                props.colDef.cellRendererParams.setCustomerContacts(opts);
                props.colDef.cellRendererParams.setLineData(props.data);
            },
            error => {
                console.log(
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString()
                );
            }
        );
    };

    const hangleEdit = () => {
        navigate("/sale/" + props.data.id);
    };

    useEffect(() => {
        if (props.node.data != null) {
            const actionel = (
                <Menu
                    position="initial"
                    direction="left"
                    menuButton={
                        <MenuButton>
                            <span style={{ color: 'black' }}><i className="fa fa-bars"></i></span>
                        </MenuButton>
                    }
                    transition
                >
                    <MenuItem onClick={handlePrint}><i className="fa fa-print"></i>{t("printMenu")}</MenuItem>
                    <MenuItem onClick={showEmailModal}><i className="fa fa-envelope"></i>{t("sendEmailMenu")}</MenuItem>
                    <MenuItem onClick={hangleEdit}><i className="fa fa-edit"></i>{t("editMenu")}</MenuItem>
                    <MenuItem onClick={handleCancel}><i className="fa fa-times"></i>{t("deletePreSaleMenu")}</MenuItem>
                </Menu>
            );
            setActionElement(actionel);
        }
    }, [props.node]);

    return <span>{actionElement}</span>;
});

export default PresalesActionRenderer;
